/* eslint-disable no-case-declarations */
import axios from "axios";
import { size } from "lodash";
import moment from "moment";
// import { get } from "lodash";
import { SERVICE_TYPE_BOTH } from "~/utils/constants";
import * as types from "./types";

const initialState = {
  partnerId: "",
  hospitalSelected: null,
  treeId: "",
  bookingTree: null,
  listNode: [],
  // subject
  subject: {
    id: "",
    list: [],
    subType: "",
    name: "",
    type: "subject",
    isHasSubject: false
  },
  subjectSearchTerm: "",
  // service
  service: {
    id: "",
    list: [],
    subType: "",
    name: "",
    price: 0,
    serviceType: "",
    serviceTypeDefault: "",
    type: "service",
    isHasService: false,
    insuranceChoice: "",
    requiredCheckInsurance: false,
    infoLine2: {}
  },
  // room
  room: {
    id: "",
    list: [],
    subType: "",
    name: "",
    type: "room",
    isHasRoom: false
  },
  // doctor
  doctor: {
    id: "",
    list: [],
    subType: "",
    name: "",
    type: "doctor",
    isHasDoctor: false
  },
  doctorSearchTerm: "",
  days: {
    date: "",
    list: []
  },
  shifts: {
    id: "",
    list: []
  },
  timeSlot: {},
  schedulesSelected: [],
  bookingReserve: null,
  loading: false,
  paymentInformation: null,
  isDirectionBack: false,
  bookingList: [],
  isRepayment: false,
  flow: "date",
  isScheduleWithoutDate: false,
  typeAction: null,
  addonServices: [],
  filterCheckData: [],
  extraConfig: {},
  isAddNewSchedule: false,
  care247SelectedId: "",
  noteAssignment: "",
  healthIndex: { height: "", weight: "" }
};

export default (state = initialState, action) => {
  // console.log(state);
  switch (action.type) {
    case types.REMOVE_SCHEDULE: {
      const { indexSchedule } = action.payload;
      state.schedulesSelected.splice(indexSchedule, 1);
      return {
        ...state,
        schedulesSelected: [...state.schedulesSelected]
      };
    }

    case types.SAVE_SCHEDULE_INDEX: {
      return {
        ...state,
        scheduleIndex: action.payload.indexSchedule
      };
    }

    case types.GET_EXTRA_CONFIG_SUCCESS: {
      return {
        ...state,
        extraConfig: action.payload
      };
    }
    // set filterCheckData id
    case types.SET_FILTER_CHECK_DATA: {
      return {
        ...state,
        filterCheckData: [action.id]
      };
    }

    // set filterCheckData id
    case types.RESET_FILTER_CHECK_DATA: {
      return {
        ...state,
        filterCheckData: []
      };
    }

    case types.RESET_ADD_ON_SERVICE: {
      return {
        ...state,

        addonServices: []
      };
    }
    // set setAddonServices id
    case types.SET_ADDONSERVICES: {
      return {
        ...state,
        addonServices: action.id
      };
    }

    // set filterCheckData id
    case types.SELECT_RADIO_SERVICE_ADDON: {
      return {
        ...state,
        addonServices: action.id
      };
    }

    case types.SET_TYPE_ACTION: {
      return {
        ...state,
        typeAction: action.value
      };
    }

    case types.OFF_LOADING: {
      return {
        ...state,
        loading: false
      };
    }
    case types.ON_LOADING: {
      return {
        ...state,
        loading: true
      };
    }

    // set partner id
    case types.SET_PARTNER_ID: {
      axios.defaults.headers.partnerid = action.payload;
      return {
        ...state,
        partnerId: action.payload
      };
    }

    // select hospital
    case types.SELECT_HOSPITAL:
      axios.defaults.headers.partnerid = action.payload;
      window.localStorage.setItem("prevPartnerId", action.payload);

      return {
        ...state,
        hospitalSelected: action.hospital,
        partnerId: action.payload
      };

    case types.GET_BOOKING_TREE_SUCCESS: {
      const { isAddNewSchedule, payload } = action;
      const { subType } = payload;
      if (subType !== null) {
        return {
          ...state,
          bookingTree: action.payload,
          [subType]: { ...state[subType], list: action.payload.child },
          listNode: action.payload.path.split("_"),
          partnerId: action.id,
          treeId: action.treeId,
          isAddNewSchedule
        };
      } else {
        return {
          ...state,
          bookingTree: action.payload,
          days: [...state?.days, action.payload?.days],
          partnerId: action.id,
          isAddNewSchedule
        };
      }
    }

    // SUBJECT
    case types.SELECT_SUBJECT: {
      const {
        subType,
        end,
        detail: { name, id: subjectId }
      } = action.payload;
      const index = state.subject.list.findIndex(sub => sub.id === subjectId);

      if (end) {
        return {
          ...state,
          subject: {
            ...state.subject,
            subType,
            id: subjectId,
            name,
            isHasSubject: true
          },
          days: {
            ...state.days,
            list: action.payload.days
          },
          isDirectionBack: false
        };
      } else {
        return {
          ...state,
          subject: {
            ...state.subject,
            subType,
            id: subjectId,
            name,
            isHasSubject: true
          },
          [subType]: {
            ...state[subType],
            list: state.subject.list[index].child
          },
          isDirectionBack: false
        };
      }
    }

    case types.RESET_SELECT_SUBJECT: {
      return {
        ...state,
        subject: { ...state.subject, id: "", name: "" },
        subjectSearchTerm: ""
      };
    }

    case types.SEARCH_SUBJECT: {
      return { ...state, subjectSearchTerm: action.payload };
    }

    // DOCTOR
    case types.SELECT_DOCTOR: {
      const {
        subType,
        end,
        detail: { name, id: doctorId, nextCombine, subject, subjectId }
      } = action.payload;

      const index = state.doctor.list.findIndex(
        doctor => doctor.id === doctorId
      );

      // xóa node nextCombine ra khỏi list node
      let newListNode = [...state.listNode];
      if (nextCombine) {
        const index = newListNode.findIndex(item => item === subType);
        newListNode = newListNode.splice(index - 1, 1);
      }

      if (end) {
        return {
          ...state,
          doctor: {
            ...state.doctor,
            subType,
            id: doctorId,
            name,
            isHasDoctor: true // check thông tin để show ở step cuôi
          },
          days: {
            ...state.days,
            list: action.payload.days
          },
          isDirectionBack: false
        };
      } else {
        return {
          ...state,
          doctor: {
            ...state.doctor,
            subType,
            id: doctorId,
            name,
            isHasDoctor: true
          },
          subject: {
            ...state.subject,
            name: subject || state.subject.name,
            id: subjectId || state.subject.id,
            isHasSubject: !!subject
          },
          [subType]: {
            ...state[subType],
            list: state.doctor.list[index].child
          },
          isDirectionBack: false,
          listNode: newListNode
        };
      }
    }

    case types.RESET_SELECT_DOCTOR: {
      return {
        ...state,
        doctor: { ...state.doctor, id: "", name: "" },
        doctorSearchTerm: ""
      };
    }

    case types.SEARCH_DOCTOR: {
      return { ...state, doctorSearchTerm: action.payload };
    }

    // SERVICE
    case types.SELECT_SERVICE: {
      const {
        subType,
        id: serviceId,
        end,
        pickType,
        detail: {
          name,
          price,
          serviceType,
          requiredCheckInsurance,
          displayDetail,
          infoLine2,
          advanced,
          ...restDetail
        }
      } = action.payload;

      const index = state.service.list.findIndex(sub => sub.id === serviceId);

      if (end) {
        return {
          ...state,
          service: {
            ...state.service,
            subType,
            id: serviceId,
            name,
            isHasService: true,
            price,
            advanced,
            serviceType:
              serviceType === SERVICE_TYPE_BOTH
                ? state.service.serviceType
                : serviceType,
            serviceTypeDefault: serviceType,
            requiredCheckInsurance,
            displayDetail,
            infoLine2,
            pickType: pickType,
            ...restDetail
          },
          days: {
            ...state.days,
            list: action.payload.days
          },
          isDirectionBack: false
        };
      } else {
        return {
          ...state,
          service: {
            ...state.service,
            subType,
            id: serviceId,
            name,
            isHasService: true,
            price,
            advanced,
            serviceType:
              serviceType === SERVICE_TYPE_BOTH
                ? state.service.serviceType
                : serviceType,
            serviceTypeDefault: serviceType,
            requiredCheckInsurance,
            displayDetail,
            infoLine2
          },
          [subType]: {
            ...state[subType],
            list: state.service.list[index].child
          },
          isDirectionBack: false,
          isHasService: true
        };
      }
    }

    case types.RESET_SELECT_SERVICE: {
      return {
        ...state,
        service: { ...state.service, id: "", name: "", serviceType: "" }
      };
    }

    case types.CHANGE_SERVICE_TYPE: {
      return {
        ...state,
        service: { ...state.service, serviceType: action.payload }
      };
    }

    // ROOM
    case types.SELECT_ROOM: {
      const {
        subType,
        end,
        detail: { name, id: roomId }
      } = action.payload;
      const index = state.room.list.findIndex(sub => sub.id === roomId);

      if (end) {
        return {
          ...state,
          room: {
            ...state.room,
            subType,
            id: roomId,
            name,
            isHasRoom: true
          },
          days: {
            ...state.days,
            list: action.payload.days
          },
          isDirectionBack: false
        };
      } else {
        return {
          ...state,
          room: {
            ...state.room,
            subType,
            id: roomId,
            name,
            isHasRoom: true
          },
          [subType]: {
            ...state[subType],
            list: state.room.list[index].child
          },
          isDirectionBack: false,
          isHasRoom: true
        };
      }
    }

    case types.RESET_SELECT_ROOM: {
      return {
        ...state,
        room: { ...state.room, id: "", name: "" }
      };
    }

    // UPDATE CURRENT NODE
    case types.UPDATE_CURRENT_NODE: {
      const { type, id } = action.node;
      const listItem = [...state[type].list];
      const index = listItem.findIndex(item => item.id === id);
      listItem.splice(index, 1, action.node);
      return {
        ...state,
        [type]: { ...state[type], list: listItem }
      };
    }

    // DATE
    case types.SELECT_DATE: {
      const date = action.payload;
      const index = state.days.list.findIndex(day =>
        moment(date).isSame(moment(day.date), "date")
      );
      return {
        ...state,
        days: { ...state.days, date },
        shifts: { ...state.shifts, list: state.days.list[index].shifts },
        isDirectionBack: false
      };
    }
    case types.RESET_SELECT_DATE:
      return { ...state, days: { ...state.days, date: null } };

    // SLOT_TIME
    case types.SELECT_TIME_SLOT:
      return {
        ...state,
        timeSlot: {
          ...state.timeSlot,
          ...action.payload,
          isDirectionBack: false
        }
      };
    case types.RESET_SELECT_TIME_SLOT:
      return { ...state, timeSlot: {} };

    // ADD_SCHEDULE
    case types.ADD_SCHEDULE: {
      const itemSchedule = {
        date: state.days.date,
        subject: { ...state.subject },
        service: { ...state.service },
        doctor: { ...state.doctor },
        time: { ...state.timeSlot },
        room: { ...state.room }
      };

      const {
        schedulesSelected,
        // subject,
        extraConfig,
        flow,
        scheduleIndex
      } = state;

      const limitBooking = extraConfig?.treeId?.[flow]?.bookingLimit || 0;

      if (schedulesSelected[scheduleIndex]) {
        schedulesSelected[scheduleIndex] = itemSchedule;

        return {
          ...state,
          schedulesSelected: [...state.schedulesSelected]
        };
      } else {
        if (size(schedulesSelected) >= limitBooking) {
          schedulesSelected.pop();
        }
        return {
          ...state,
          schedulesSelected: [...state.schedulesSelected, itemSchedule]
        };
      }
    }

    case types.ADD_SCHEDULE_REPAYMENT: {
      const { paymentInformation } = state;

      return {
        ...state,
        treeId: paymentInformation?.[0]?.bookingInfo?.treeId,
        schedulesSelected: paymentInformation.map(item => {
          const {
            subject,
            service,
            room,
            doctor,
            time,
            date,
            id,
            addonServices,
            medproCare
          } = item.bookingInfo;

          const dateUnix = moment(date).unix() * 1000;
          const startTime = time ? moment(time.startTime).format("HH:mm") : "";
          const endTime = time ? moment(time.endTime).format("HH:mm") : "";

          return {
            id,
            date: dateUnix,
            subject,
            service: {
              ...service,
              addonMedproCare: medproCare?.addonServices,
              medproCareNote: medproCare?.medproCareNote
            },
            room,
            doctor,
            time: { ...time, startTime, endTime },
            addonServices: addonServices
          };
        })
      };
    }

    case types.RESET_SCHEDULE: {
      return {
        ...state,
        schedulesSelected: []
      };
    }

    // BOOKING
    case types.RESERVE_BOOKING:
      return { ...state, loading: true };

    case types.RESERVE_BOOKING_SUCCESS:
      return {
        ...state,
        bookingReserve: action.payload,
        loading: false
      };

    case types.RESERVE_BOOKING_FAILURE:
      return {
        ...state,
        loading: false
      };

    case types.GET_PAYMENT_INFO: {
      return { ...state, loading: true };
    }

    case types.GET_PAYMENT_INFO_SUCCESS: {
      return { ...state, paymentInformation: action.payload, loading: false };
    }

    // MEDICAL BILL
    case types.GET_ALL_MEDICAL_BILLS_SUCCESS: {
      return {
        ...state,
        bookingList: action.payload
      };
    }
    case types.SELECT_MEDICAL_BILL: {
      axios.defaults.headers.partnerid = action.payload;
      return {
        ...state,
        hospitalSelected: action.hospital,
        partnerId: action.payload
      };
    }

    // CHANGE DIRECTION
    case types.CHANGE_DIRECTION: {
      return { ...state, isDirectionBack: true };
    }

    // CHECK REPAYMENT
    case types.CHECK_REPAYMENT: {
      return { ...state, isRepayment: action.payload };
    }

    // RESET DATA
    case types.RESET_DATA:
      window.localStorage.removeItem("partnerId");
      return {
        ...initialState,
        extraConfig: state.extraConfig,
        flow: state.flow,
        typeAction: state.typeAction
      };

    // RESET DATA LUỒNG ĐẶT KHÁM: giữ bệnh viện, cấu hình và loại thao tác, còn lại reset hết
    case types.RESET_BOOKING_FLOW_DATA:
      return {
        ...initialState,
        partnerId: state.partnerId,
        hospitalSelected: state.hospitalSelected,
        extraConfig: state.extraConfig,
        typeAction: state.typeAction,
        flow: state.flow
      };

    case types.CHANGE_BOOKING_FLOW:
      return { ...state, flow: action.flow, treeId: action.flow.toUpperCase() };

    // SET INSURANCE TYPE FOR LELOI
    case types.SET_INSURANCE_CHOICE: {
      return {
        ...state,
        service: { ...state.service, insuranceChoice: action.payload }
      };
    }

    case types.SET_SCHEDULE_WITHOUT_DATE: {
      return {
        ...state,
        isScheduleWithoutDate: action.payload
      };
    }
    case types.SET_PAYMENT_INFOMATION_BY_CSKH: {
      return {
        ...state,
        paymentInformation: {
          ...state.paymentInformation,
          bookingInfo: action.payload
        }
      };
    }

    case types.BOOKING_INFO_CSKH_SUCCESS: {
      return {
        ...state,
        paymentInformation: action.payload
      };
    }

    case types.RESET_BOOKING_STEP_DATE: {
      return {
        ...state,
        service: initialState.service,
        doctor: initialState.doctor,
        subject: initialState.subject,
        room: initialState.room,
        days: initialState.days,
        shifts: initialState.shifts
      };
    }

    case types.SELECT_CARE247_SERVICE: {
      return {
        ...state,
        care247SelectedId: action.payload
      };
    }

    case types.SET_NOTE_ASSIGNMENT: {
      return {
        ...state,
        noteAssignment: action.payload
      };
    }
    case types.SET_HEALTH_INDEX: {
      return {
        ...state,
        healthIndex: action.payload
      };
    }

    default:
      return state;
  }
};
